export default "__VITE_ASSET__Bmz7kWis__"